import { render, staticRenderFns } from "./UserPermissionToggle.vue?vue&type=template&id=5e047cb4&scoped=true"
import script from "./UserPermissionToggle.vue?vue&type=script&lang=ts"
export * from "./UserPermissionToggle.vue?vue&type=script&lang=ts"
import style0 from "./UserPermissionToggle.vue?vue&type=style&index=0&id=5e047cb4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e047cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e047cb4')) {
      api.createRecord('5e047cb4', component.options)
    } else {
      api.reload('5e047cb4', component.options)
    }
    module.hot.accept("./UserPermissionToggle.vue?vue&type=template&id=5e047cb4&scoped=true", function () {
      api.rerender('5e047cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UserPermissionToggle.vue"
export default component.exports